export default {
  noSamePass: 'hasła się różnią',
  loginSuccess: 'zalogowano pomyślnie',
  registerSuccess: 'zarejestrowano pomyślnie',
  isHaveAccount: 'Masz już konto?',
  login: 'Zaloguj się',
  logout: 'Wyloguj się',
  forgetPass: 'Zapomniałeś hasła?',
  register: 'Zarejestruj się',
  registered: 'Mam już konto,',
  emailTips: 'E-mail',
  password: 'Hasło',
  pwdErr: 'Nieprawidłowe hasło.',
  confirmPass: 'Potwierdź hasło',
  countryTips: 'Wybierz swój kraj',
  inviteCodeTips: 'Wprowadź kod zaproszenia (opcjonalnie)',
  verifyEmpty: 'pole nie może być puste',
  verifyEmail: 'Proszę wpisać poprawny format adresu e-mail',
  verifyUrl: 'Proszę wpisać poprawny format URL',
  verifyPass: 'hasło musi zawierać minimum 6 znaków oraz litery i cyfry',
  confirmText: 'Przeczytałem i akceptuję',
  agreementName: '《Regulamin rejestracji użytkownika acbuy》',
  verifyCode: 'Kod weryfikacyjny',
  loginPwd: 'Hasło logowania',
  editPwd: 'Zmień hasło',
  changePwd: 'Zmień hasło logowania',
  setPwd: 'Ustaw hasło',
  and: 'oraz',
  privacyStatement: '《politykę prywatności》',
  confirm: 'Potwierdź',
  cancel: 'Anuluj',
  editSuccess: 'Zmieniono pomyślnie',
  email: 'E-mail',
  emailCode: 'Weryfikacja e-mail',
  newPwd: 'Nowe hasło',
  button: {
    search: 'Szukaj',
    query: 'SPRAWDŹ TERAZ',
    reset: 'Resetuj',
    submit: 'Zatwierdź',
    submitOrder: 'Złóż zamówienie',
    save: 'Zapisz',
  },
  holder: {
    select: 'wybierz',
    startTime: 'Data początkowa',
    endTime: 'Data końcowa',
    max: 'maksymalna',
    min: 'minimalna',
    inputContent: 'Wprowadź treść',
    inputEmailAccount: 'Wprowadź prawidłowy adres e-mail',
  },
  back: 'Witaj z powrotem!',
  continueGoogle: 'Kontynuuj z Google',
  notAccount: 'Nie masz konta?',
  signNow: 'Zarejestruj się teraz',
  termService: 'Warunki usługi',
  privacyPolicy: 'Polityka prywatności',
  helpCenter: 'Centrum pomocy',
  readPrivacy: 'Przeczytałem i akceptuję',
  verifyAccept: 'nie przeczytano regulaminu',
  accountSecurity: 'Bezpieczeństwo konta',
  loginNow: 'Zaloguj się teraz',
  resetPsd: 'Zresetuj hasło',
  verifiedEmail: 'Zweryfikuj e-mail',
  unverified: 'niezweryfikowany',
  emailVerification: 'Weryfikacja e-mail',
  verifyMsg:
    'Twój e-mail nie został zweryfikowany, więc tymczasowo nie możemy zrealizować zakupów. Prosimy o weryfikację e-maila w centrum osobistym.',
  sendVerificationEmail: 'Wyślij e-mail weryfikacyjny',
  linkHasExpired: 'Link wygasł!',
  hasSendEmail: 'Wysłano e-mail weryfikacyjny',
  shippingFeeEstimation: 'Szacowanie kosztów wysyłki',
  homeText: 'Strona główna',
  loginBgMsg: 'Dołącz do Discord acbuy, aby uzyskać więcej korzyści',
  registerTitleMsg: 'ROZPOCZNIJ SWOJĄ PODRÓŻ',
  registerBgMsg: 'Nowi użytkownicy otrzymują kupony na wysyłkę o wartości 340$',
  announcement: 'Ogłoszenie',
  formAnnouncementMsg:
    'Nowy model programu partnerskiego, model podwójnej prowizji od przesyłek, używaj go, aby zarabiać i oszczędzać',
  incorrectAmount: 'Kwota wypłaty musi być większa niż 0',
  readPrivacy1: 'Przeczytałem',
  andAgree: 'i akceptuję',
  aboveContent: 'powyższą treść',
  purchasingNotice: 'Informacja o zakupie',
  afterSaleService: 'obsługa posprzedażowa',
  uniOrderAgreeText:
    'Link, który przesłałeś na tej stronie, należy do linków produktów stron trzecich (takich jak Xianyu, Xiaohongshu, Bilibili itp.), a acbuy może tylko pomóc Ci znaleźć sprzedawcę linku w celu konsultacji produktu, zakupu i organizacji usług logistycznych stron trzecich. acbuy nie może rozróżnić jakości i autentyczności produktu, a przed złożeniem zamówienia musisz ponieść związane z tym ryzyko.',
  excludeFees: 'Ważna informacja: opłaty za wysyłkę międzynarodową będą obliczane oddzielnie.',
  selectProductBtn: 'Wybierz produkty z mojego magazynu',
}
